import { Transerializable, IConfigurable, GetterConfigArgs, objectOr, arrayOr } from '@eventops/athlinks-get-or'
import {Distance, IDistance} from '../common/distance'
import {IntervalRaceType} from '../common/raceType'
import {IPace, Pace} from '../common/pace'
import {ITime, Time} from '../common/time'
import {RaceTimeType} from '../common/raceType'
import {CalendarTime, ICalendarTime} from '../common/calendarTime'

export enum IntervalType {
  SPLIT = 'split',
  COURSE = 'course',
  UNDEFINED = 'undefined'
}

export interface IIntervalResult {
  distance: IDistance,
  intervalFull: boolean,
  intervalId: number,
  intervalName: string,
  intervalOrder: number,
  intervalRaceType: IntervalRaceType,
  intervalType: IntervalType,
  brackets: IBracketResult[],
  crossingDateTimeInMilliseconds: number
  mostRecentInterval: boolean,
  pace: IPace,
  chipTime: ITime | undefined,
  gunTime: ITime | undefined,
  timeWithPenalties: ITime,
}

export class IntervalResult extends Transerializable implements IIntervalResult, IConfigurable {
  config: GetterConfigArgs = {
    optionalPartialConfig: {
      gunTime: {
        getter: objectOr,
        decorators: (time: any) =>
          Time.build({json: time})
      },
      chipTime: {
        getter: objectOr,
        decorators: (time: any) =>
          Time.build({json: time})
      }
    }
  }
  public brackets: IBracketResult[] = []
  public crossingDateTimeInMilliseconds = 0
  public mostRecentInterval = false
  public pace = new Pace()
  public chipTime = new Time()
  public gunTime = new Time()
  public timeWithPenalties = new Time()
  public distance = new Distance()
  public intervalFull = false
  public intervalId = 0
  public intervalName = ''
  public intervalOrder = 0
  public intervalRaceType = IntervalRaceType.UNDEFINED
  public intervalType = IntervalType.UNDEFINED
}

export interface IBracketResult {
  bracketName: string,
  bracketOrder: number
  bracketPublishResults: boolean,
  bracketRankType: RaceTimeType,
  bracketTag: string,
  bracketType: string,
  id: number,
  isPrimary: boolean,
  rank: number,
  totalAthletes: number,
  totalInBracket?: number
}

export class BracketResult extends Transerializable implements IBracketResult {
  public bracketName = ''
  public bracketOrder = 0
  public bracketPublishResults = false
  public bracketRankType = RaceTimeType.CHIP
  public bracketTag = ''
  public bracketType = ''
  public id = 0
  public isPrimary = false
  public rank = 0
  public totalAthletes = 0
}

// final object for IRP response.
export interface IIndividualResult {
  age: number,
  bib: string,
  country: string,
  courseId: number,
  displayName: string,
  entryStatus: string,
  entryType: string,
  entryId: number,
  entryUniqueId: string,
  eventCourseId: number,
  eventId: number,
  eventStartTime: ICalendarTime,
  eventTimeZone: string,
  firstName: string,
  gender: string,
  intervals: IIntervalResult[],
  isProfilePublic: boolean,
  isValidEmail: boolean,
  lastName: string,
  locality: string,
  overallBracketRaceRankType: RaceTimeType,
  raceId: number,
  racerId: number,
  raceName: string,
  raceStartTime: ICalendarTime,
  racerHasFinished: boolean,
  racerStartTime: ICalendarTime,
  region: string,
  regionId: string,
  thirdPartyEventCourseId: number,
  thirdPartyEntryId: number,
  isVirtual: boolean,
  minAllowedTicks: number,
  maxAllowedTicks: number,
  eventEndTime: ICalendarTime
}

export class IndividualResult extends Transerializable implements IIndividualResult, IConfigurable {
 config: GetterConfigArgs = {
    optionalPartialConfig: {
      intervals: {
        getter: arrayOr,
        decorators: (ir: any) =>
          IntervalResult.build({json: ir})
      }
    }
  }
  public age = 0
  public courseId = 0
  public eventCourseId = 0
  public eventId = 0
  public bib = ''
  public country = ''
  public displayName = ''
  public entryStatus = ''
  public entryType = ''
  public entryId = 0
  public entryUniqueId = ''
  public eventStartTime = new CalendarTime()
  public eventTimeZone = ''
  public firstName = ''
  public gender = ''
  public intervals: IIntervalResult[] = []
  public isProfilePublic = false
  public isValidEmail = false
  public lastName = ''
  public locality = ''
  public raceId = 0
  public raceStartTime = new CalendarTime()
  public racerId = 0
  public raceName = ''
  public overallBracketRaceRankType = RaceTimeType.UNDEFINED
  public racerHasFinished = false
  public racerStartTime = new CalendarTime()
  public region = ''
  public regionId = ''
  public thirdPartyEventCourseId = 0
  public thirdPartyEntryId = 0
  public isVirtual = false
  public minAllowedTicks = 0
  public maxAllowedTicks = 0
  public eventEndTime = new CalendarTime()
}
